var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinegraph({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.015,
    y1: -43.677,
    x2: 0.973,
    y2: -44.79,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0077d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b59a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -103.833,
    x2: 1,
    y2: -103.833,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7dd8f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45b0d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.25,
    y1: -103.472,
    x2: 0.677,
    y2: -104.09,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#75daff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49bef1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "line-graph",
    transform: "translate(-4 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4013",
    "data-name": "Path 4013",
    d: "M4,43.75V15H54V43.75a2.507,2.507,0,0,1-2.5,2.5H6.5A2.507,2.507,0,0,1,4,43.75Z",
    transform: "translate(0 1.75)",
    fill: "#f2f3f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4014",
    "data-name": "Path 4014",
    d: "M54,10.5v6.25H4V10.5A2.507,2.507,0,0,1,6.5,8h45A2.507,2.507,0,0,1,54,10.5Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4015",
    "data-name": "Path 4015",
    d: "M16.625,13.75h31.25a.625.625,0,0,0,.625-.625v-2.5A.625.625,0,0,0,47.875,10H16.625a.625.625,0,0,0-.625.625v2.5A.625.625,0,0,0,16.625,13.75Z",
    transform: "translate(3 0.5)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_428",
    "data-name": "Ellipse 428",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(7 11)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_429",
    "data-name": "Ellipse 429",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(13 11)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4016",
    "data-name": "Path 4016",
    d: "M30.927,35.194l-8.75-8.75-9.116,9.116-1.767-1.768L22.177,22.909l8.75,8.75L41.293,21.293l1.768,1.768Z",
    transform: "translate(1.823 3.323)",
    fill: "#0d62ab"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_430",
    "data-name": "Ellipse 430",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(42 23)",
    fill: "#199be2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(30 34)",
    fill: "#199be2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_432",
    "data-name": "Ellipse 432",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(22 26)",
    fill: "#199be2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_433",
    "data-name": "Ellipse 433",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(12 36)",
    fill: "#199be2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinegraph);
export default __webpack_public_path__ + "static/media/linegraph.60083dc414fb08066b7beb59e8facdaf.svg";
export { ForwardRef as ReactComponent };